import React, { useState } from 'react';
import { Input } from '../input/input.index';
import { faNumToEnNum } from '../../../scripts';

interface OtpInputProps {
    length: number;
    onChange: (otp: string) => void;
    className?: string;
}

const OtpInput: React.FC<OtpInputProps> = ({ length, onChange, className }) => {
    const [otp, setOtp] = useState<string>('');

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = faNumToEnNum(e.target.value.replace(/[^0-9]/g, ''));
        if (value.length <= length) {
            setOtp(value);
            onChange(value);
        }
    };

    return (
        <Input
            type="text"
            inputMode="numeric"
            value={otp}
            onChange={handleChange}
            maxLength={length}
            className={`w-${length * 1.5}ch text-center text-base h-14 max-lg:h-12 max-lg:text-sm ${className ? className : ''}`}
            style={{ letterSpacing: '0.5em', direction: 'ltr' }}
        />
    );
};

export default OtpInput;